export default __webpack_public_path__ + "static/media/Kilt of the Primal Spirit.d93b935b.jpg";